<div id="mySidenav" [ngClass]="sidebarExpanded ? 'open sidenav' : 'open2 sidenav' ">
  <div class="row mx-0 pb-3 mb-3" style="border-bottom: 1px solid white;">
    <div class="col-9 d-flex align-items-start">
      <img src="/assets/img/logo-admin.svg" class="img-responsive" >
      <div class="ml-2 text-white pt-1">
        <p class="font-size-16 m-0">Eficacia</p>
        <p class="font-size-12 m-0">DIY SaaS </p>
      </div>

    </div>
    <div class="col-3">
      <a href="javascript:void(0)" class="closebtn font-size-24" onclick="closeNav()"> <i class="icon-arrow_left"></i> </a>
    </div>
  </div>
  <div class="row mx-0 pb-3 mb-3" style="border-bottom: 1px solid white;">
    <div class="col-8 pr-0">
        <input type="text" class="form-control rounded-8 font-size-12" placeholder="¿Qué quieres buscar?">
    </div>
    <div class="col-4 ">
        <button class="btn-search-icon">
            <i class="icon-search_normal text-white font-size-20"></i>
        </button>
    </div>
  </div>
  <div class="row mx-0 pb-2 mb-3" style="border-bottom: 1px solid white;">
    <ul class="list-menu">
      <li>
        <a class="font-solomon font-size-18 text-white  font-solomon-bold" href="" >
          <i class="icon-house"></i>
                    Inicio
        </a>
      </li>
      <li>

        <a class="font-solomon font-size-18 text-white  font-solomon-bold" href="notifications" >
          <i class="icon-notification"></i>
                    Notificaciones
        </a>
      </li>
      <li>
        <a class="font-solomon font-size-18 text-white  font-solomon-bold" href="services">
          <i class="icon-box"></i>
          Servicios
        </a>
      </li>
      <li>
        <a class="font-solomon font-size-18 text-white font-solomon-bold" href="#">
          <i class="icon-status-up"></i>
                    Reportes
        </a>
      </li>
      <li>
        <a class="font-solomon font-size-18 text-white" [routerLink]="['/settings/']">
          <i class="icon-settings"></i>
                    Parametrización
        </a>
      </li>
    </ul>
  </div>
  <div class="row mx-0 pb-2 mb-3" style="border-bottom: 1px solid white;">
    <p class="subtitle-menu font-solomon-bold font-size-18 text-white mb-0">Accesos rápidos</p>
    <ul  class="list-menu">
      <li>
        <a class="font-solomon font-size-18 text-white  font-solomon-bold" [routerLink]="['/moments/']">
          <i class="icon-star"></i>
                    Momentos
        </a>
      </li>
      <li>
        <a class="font-solomon font-size-18 text-white font-solomon-bold" href="forms">
          <i class="icon-star"></i>
                    Formularios
        </a>
      </li>
      <li>
        <a class="font-solomon font-size-18 text-white font-solomon-bold" [routerLink]="['/business-dynamics/available-dynamics/list']">
          <i class="icon-star"></i>
                    {{ 'Dinamicas comerciales' | translate }}
        </a>
      </li>

    </ul>
  </div>
  <div class="row mx-0 mt-3 pb-2">
    <div class="row mx-0 pb-2 bottom-list" >
      <ul class="list-menu mb-0 mt-3 mb-2">
        <li>
          <a class="font-solomon font-size-18 text-white" href="#" (click)="logout()">
            <i class="icon-logout"></i>
                        Cerrar sesión
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
